import { IDomainResource } from '../Resource';
import { IBackboneElement } from '../BackboneElement';
import { IAddress } from '../Address';
import { IContactPoint } from '../ContactPoint';
import { IHumanName } from '../HumanName';
import { ICodeableConcept } from '../CodeableConcept';
import { IIdentifier } from '../Identifier';
import { IReference } from '../Reference';

export type OrganizationType = 'Organization';
export const isOrganization = (
  resource: object | null | undefined,
): resource is IOrganization =>
  !!resource && (resource as IOrganization).resourceType === 'Organization';
export interface IOrganizationContact extends IBackboneElement {
  purpose?: ICodeableConcept;
  name?: IHumanName;
  telecom?: IContactPoint;
  address?: IAddress;
}
export interface IOrganization extends IDomainResource<OrganizationType> {
  identifier?: IIdentifier[];
  active?: boolean;
  type?: ICodeableConcept[];
  name?: string;
  alias?: string[];
  telecom?: IContactPoint[];
  address?: IAddress[];
  partOf?: IReference;
  contact?: IOrganizationContact[];
  endpoint?: IReference[];
}
